/* DoormatsUSA custom coir DPO presentation layer.
   Keeps ITORIS/DPO selects as the source of truth and mirrors only the UI. */
(function () {
  var PRODUCT_ID = '9363741278313';
  var ROOT_SELECTOR = 'product-info[data-product-id="' + PRODUCT_ID + '"]';
  var ENHANCED_ATTR = 'data-dusa-custom-coir-enhanced';

  var FIELD_MAP = {
    '1001': { role: 'length-feet', label: 'Feet', row: 'length' },
    '1002': { role: 'length-inches', label: 'Inches', row: 'length' },
    '1003': { role: 'width-feet', label: 'Feet', row: 'width' },
    '1004': { role: 'width-inches', label: 'Inches', row: 'width' },
    '1005': { role: 'thickness', label: 'Thickness', row: 'options', mirror: 'thickness' },
    '1006': { role: 'color', label: 'Color', row: 'options', mirror: 'color' }
  };
  var THICKNESS_FIELD_ID = '1005';
  var COLOR_FIELD_ID = '1006';
  var FIVE_EIGHTHS_PATTERN = /5\s*\/\s*8/;
  var PREMIUM_COLOR_PATTERN = /chocolate|black/i;
  var NATURAL_COLOR_PATTERN = /natural/i;

  function q(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function parsePrice(option) {
    var raw = option && option.getAttribute('price');
    var value = raw ? parseFloat(raw) : 0;
    return Number.isFinite(value) ? value : 0;
  }

  function formatRate(price, type) {
    if (type === 'thickness') return '';
    if (!price) return 'Standard';
    return '$' + price.toFixed(2).replace(/\.00$/, '') + ' / sq ft';
  }

  function formatMoney(cents) {
    var value = Math.max(0, Math.round(cents || 0)) / 100;
    return '$' + value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function selectedOption(select) {
    return select && select.options ? select.options[select.selectedIndex] : null;
  }

  function selectedNumber(select) {
    var option = selectedOption(select);
    if (!option || !option.value) return null;
    var value = parseFloat(cleanText(option.textContent));
    return Number.isFinite(value) ? value : null;
  }

  function updateAtcPriceEcho(root, state, cents) {
    var echo = q(root, '[data-dusa-custom-coir-atc-price]');
    if (!echo) return;
    var label = q(echo, '[data-dusa-custom-coir-atc-price-label]');
    var amount = q(echo, '[data-dusa-custom-coir-atc-price-amount]');
    if (label) label.textContent = state === 'configured' ? 'Your price' : 'Starting at';
    if (amount) amount.textContent = formatMoney(cents);
    if (state === 'configured') {
      echo.setAttribute('data-dusa-price-state', 'configured');
    } else {
      echo.removeAttribute('data-dusa-price-state');
    }
  }

  function updateLivePrice(root) {
    var priceBox = q(root, '[data-dusa-custom-coir-live-price]');
    if (!priceBox) return;

    var amount = q(priceBox, '[data-dusa-custom-coir-price-amount]');
    var label = q(priceBox, '[data-dusa-custom-coir-price-label]');
    var copy = q(priceBox, '[data-dusa-custom-coir-price-copy]');
    var startingCents = parseInt(priceBox.getAttribute('data-starting-price-cents') || '0', 10) || 0;

    var lengthFeet = selectedNumber(selectForField(root, '1001'));
    var lengthInches = selectedNumber(selectForField(root, '1002'));
    var widthFeet = selectedNumber(selectForField(root, '1003'));
    var widthInches = selectedNumber(selectForField(root, '1004'));
    var thicknessSelect = selectForField(root, THICKNESS_FIELD_ID);
    var thicknessOption = selectedOption(thicknessSelect);
    var colorOption = selectedOption(selectForField(root, COLOR_FIELD_ID));

    var hasCompleteSize = lengthFeet !== null && lengthInches !== null && widthFeet !== null && widthInches !== null;
    var hasThickness = thicknessOption && thicknessOption.value;

    if (!hasCompleteSize || !hasThickness) {
      if (amount) amount.textContent = formatMoney(startingCents);
      if (label) label.textContent = 'Starting at';
      if (copy) copy.textContent = 'Updates as you choose length, width, thickness, and color.';
      priceBox.removeAttribute('data-dusa-price-state');
      updateAtcPriceEcho(root, 'starting', startingCents);
      return;
    }

    var length = lengthFeet + (lengthInches / 12);
    var width = widthFeet + (widthInches / 12);
    var squareFeet = length * width;
    var rate = parsePrice(thicknessOption) + parsePrice(colorOption);
    var totalCents = Math.round(squareFeet * rate * 100);

    if (amount) amount.textContent = formatMoney(totalCents);
    if (label) label.textContent = 'Current price';
    if (copy) copy.textContent = 'For your selected size, thickness, and color.';
    priceBox.setAttribute('data-dusa-price-state', 'configured');
    updateAtcPriceEcho(root, 'configured', totalCents);
  }

  function displayLabelForOption(option, type) {
    var text = cleanText(option.textContent).replace(/\s*\+\$[\d.,]+/g, '');
    if (type === 'thickness') return text;
    return text;
  }

  function selectForField(root, fieldId) {
    return q(root, '#select_' + fieldId + ', select[name="options[' + fieldId + ']"]');
  }

  function isFiveEighthsThicknessOption(option) {
    return FIVE_EIGHTHS_PATTERN.test(cleanText(option && option.textContent));
  }

  function isFiveEighthsSelected(select) {
    if (!select) return false;
    var option = select.options[select.selectedIndex];
    return isFiveEighthsThicknessOption(option);
  }

  function isPremiumColorOption(option) {
    return PREMIUM_COLOR_PATTERN.test(displayLabelForOption(option, 'color'));
  }

  function findNaturalColorOption(select) {
    if (!select) return null;
    return Array.prototype.slice.call(select.options || []).find(function (option) {
      return option.value && NATURAL_COLOR_PATTERN.test(displayLabelForOption(option, 'color'));
    }) || null;
  }

  function swatchClass(label) {
    var lower = label.toLowerCase();
    if (lower.indexOf('black') > -1) return 'black';
    if (lower.indexOf('chocolate') > -1) return 'chocolate';
    return 'natural';
  }

  function dispatchChange(select) {
    select.dispatchEvent(new Event('change', { bubbles: true }));
    if (window.jQuery) window.jQuery(select).trigger('change');
  }

  function normalizeSelectOptions(select) {
    Array.prototype.slice.call(select.options || []).forEach(function (option) {
      var text = cleanText(option.textContent);
      if (/please select/i.test(text)) option.textContent = 'Select...';
    });
  }

  function setHelpText(select, config) {
    var field = select.closest('.field');
    if (!field) return;
    var help = q(field, '.control p.no-margin');
    if (!help) return;
    if (config.role === 'length-feet') help.textContent = 'Max 6 ft total.';
    if (config.role === 'width-feet') help.textContent = 'Max 33 ft total.';
  }

  function normalizeDimensionHelp(root) {
    qa(root, 'select.product-custom-option').forEach(normalizeSelectOptions);
    var lengthHelp = q(root, '.dusa-custom-coir-field--length-feet .control p.no-margin');
    var widthHelp = q(root, '.dusa-custom-coir-field--width-feet .control p.no-margin');
    if (lengthHelp) lengthHelp.textContent = 'Max 6 ft total.';
    if (widthHelp) widthHelp.textContent = 'Max 33 ft total.';
  }

  function relabelField(select, config) {
    normalizeSelectOptions(select);
    var field = select.closest('.field');
    if (!field) return;
    field.classList.add('dusa-custom-coir-field', 'dusa-custom-coir-field--' + config.role);
    var label = q(field, 'label');
    if (label) label.textContent = config.label;
    var cell = field.closest('td');
    if (cell) cell.classList.add('dusa-custom-coir-cell', 'dusa-custom-coir-cell--' + config.role);
    var row = field.closest('tr.fields');
    if (row) {
      row.classList.add('dusa-custom-coir-row', 'dusa-custom-coir-row--' + config.row);
      if (config.row === 'length') row.setAttribute('data-dusa-label', 'Length');
      if (config.row === 'width') row.setAttribute('data-dusa-label', 'Width');
      if (config.row === 'options') row.setAttribute('data-dusa-label', '');
    }
    setHelpText(select, config);
  }

  function buildChoice(select, type, option) {
    var label = displayLabelForOption(option, type);
    var price = parsePrice(option);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'dusa-custom-coir-choice dusa-custom-coir-choice--' + type;
    button.setAttribute('data-value', option.value);
    button.setAttribute('aria-pressed', select.value === option.value ? 'true' : 'false');
    if (type === 'color' && isPremiumColorOption(option)) {
      button.setAttribute('data-dusa-color-limited-to', '5/8');
    }

    if (type === 'color') {
      var swatch = document.createElement('span');
      swatch.className = 'dusa-custom-coir-choice__swatch dusa-custom-coir-choice__swatch--' + swatchClass(label);
      swatch.setAttribute('aria-hidden', 'true');
      button.appendChild(swatch);
      var wrap = document.createElement('span');
      wrap.className = 'dusa-custom-coir-choice__body';
      wrap.innerHTML = '<span class="dusa-custom-coir-choice__main"></span><span class="dusa-custom-coir-choice__meta"></span>';
      q(wrap, '.dusa-custom-coir-choice__main').textContent = label;
      q(wrap, '.dusa-custom-coir-choice__meta').textContent = price ? '+$' + price.toFixed(2).replace(/\.00$/, '') + ' / sq ft' : 'No upcharge';
      button.appendChild(wrap);
    } else {
      button.innerHTML = '<span class="dusa-custom-coir-choice__main"></span><span class="dusa-custom-coir-choice__meta"></span>';
      q(button, '.dusa-custom-coir-choice__main').textContent = label;
      q(button, '.dusa-custom-coir-choice__meta').textContent = formatRate(price, type);
    }

    button.addEventListener('click', function () {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      select.value = option.value;
      dispatchChange(select);
      updateChoiceState(select);
    });
    return button;
  }

  function ensureColorAvailabilityNote(field) {
    var note = q(field, '.dusa-custom-coir-color-note');
    if (note) return note;
    note = document.createElement('p');
    note.className = 'dusa-custom-coir-color-note';
    note.textContent = 'Chocolate Brown and Black are available with 5/8" thickness only.';
    var label = q(field, 'label');
    if (label && label.nextSibling) {
      label.parentNode.insertBefore(note, label.nextSibling);
    } else {
      field.insertBefore(note, field.firstChild);
    }
    return note;
  }

  function ensureColorResetNotice(field) {
    var notice = q(field, '.dusa-custom-coir-color-reset-notice');
    if (notice) return notice;
    notice = document.createElement('p');
    notice.className = 'dusa-custom-coir-color-reset-notice';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.hidden = true;
    field.appendChild(notice);
    return notice;
  }

  function showColorResetNotice(field, message) {
    var notice = ensureColorResetNotice(field);
    notice.textContent = message;
    notice.hidden = false;
    window.clearTimeout(notice._dusaHideTimer);
    notice._dusaHideTimer = window.setTimeout(function () {
      notice.hidden = true;
    }, 5000);
  }

  function setChoiceMeta(button, text) {
    var meta = q(button, '.dusa-custom-coir-choice__meta');
    if (meta) meta.textContent = text;
  }

  function setPremiumColorAvailability(colorSelect, enabled) {
    Array.prototype.slice.call(colorSelect.options || []).forEach(function (option) {
      if (!option.value || !isPremiumColorOption(option)) return;
      option.disabled = !enabled;
    });

    var field = colorSelect.closest('.field');
    if (!field) return;
    qa(field, '.dusa-custom-coir-choice--color').forEach(function (button) {
      var option = Array.prototype.slice.call(colorSelect.options || []).find(function (candidate) {
        return candidate.value === button.getAttribute('data-value');
      });
      var isLimitedColor = option && isPremiumColorOption(option);
      if (!isLimitedColor) return;

      button.disabled = !enabled;
      button.classList.toggle('dusa-custom-coir-choice--disabled', !enabled);
      button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      setChoiceMeta(button, enabled ? '+$' + parsePrice(option).toFixed(2).replace(/\.00$/, '') + ' / sq ft' : '5/8" only');
    });
  }

  function enforceColorAvailability(root, options) {
    var thicknessSelect = selectForField(root, THICKNESS_FIELD_ID);
    var colorSelect = selectForField(root, COLOR_FIELD_ID);
    if (!thicknessSelect || !colorSelect) return;

    var colorField = colorSelect.closest('.field');
    if (colorField) {
      ensureColorAvailabilityNote(colorField);
      ensureColorResetNotice(colorField);
    }

    var premiumColorsEnabled = isFiveEighthsSelected(thicknessSelect);
    var selectedOption = colorSelect.options[colorSelect.selectedIndex];
    if (!premiumColorsEnabled && selectedOption && selectedOption.value && isPremiumColorOption(selectedOption)) {
      var natural = findNaturalColorOption(colorSelect);
      if (natural) {
        colorSelect.value = natural.value;
        dispatchChange(colorSelect);
        if (colorField && options && options.showResetNotice) {
          showColorResetNotice(colorField, 'Chocolate Brown and Black are only available in 5/8". Color reset to Natural Brown.');
        }
      }
    }

    setPremiumColorAvailability(colorSelect, premiumColorsEnabled);
    updateChoiceState(colorSelect);
  }

  function updateChoiceState(select) {
    var field = select.closest('.field');
    if (!field) return;
    qa(field, '.dusa-custom-coir-choice').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-value') === select.value ? 'true' : 'false');
    });
  }

  function createChoiceMirror(select, type) {
    var field = select.closest('.field');
    if (!field || field.querySelector('.dusa-custom-coir-choice-grid')) return;

    var options = Array.prototype.slice.call(select.options).filter(function (option) {
      return option.value && !/select/i.test(cleanText(option.textContent));
    });
    if (!options.length) return;

    select.classList.add('dusa-custom-coir-choice-select-fallback');
    // dusa a11y: the native <select> stays in the DOM (JS drives it via change events) but is hidden
    // via the clip/visually-hidden pattern, not display:none. Take it out of the tab order + AT tree
    // so it isn't a focusable "ghost" beside the visible button grid (lost focus + double announcement).
    select.setAttribute('aria-hidden', 'true');
    select.setAttribute('tabindex', '-1');
    var grid = document.createElement('div');
    grid.className = 'dusa-custom-coir-choice-grid dusa-custom-coir-choice-grid--' + type;
    grid.setAttribute('role', 'group');
    var label = q(field, 'label');
    if (label && !label.id) label.id = 'dusa-custom-coir-label-' + type;
    if (label && label.id) grid.setAttribute('aria-labelledby', label.id);

    options.forEach(function (option) {
      grid.appendChild(buildChoice(select, type, option));
    });

    select.parentNode.insertBefore(grid, select.nextSibling);
    select.addEventListener('change', function () { updateChoiceState(select); });

    var note = document.createElement('p');
    note.className = 'dusa-custom-coir-price-note';
    if (type === 'thickness') {
      note.innerHTML = '<strong>Choose the thickness that best fits your doorway clearance.</strong>';
      field.appendChild(note);
    } else if (type === 'color') {
      ensureColorAvailabilityNote(field);
      ensureColorResetNotice(field);
    }
  }

  function injectAtcPriceEcho(root) {
    // Echo the live price beside Add to cart so the commit moment shows the
    // configured total without scrolling back to the product header.
    var buttons = q(root, '.product-form__buttons');
    if (!buttons || q(root, '[data-dusa-custom-coir-atc-price]')) return;

    var priceBox = q(root, '[data-dusa-custom-coir-live-price]');
    var startingCents = priceBox ? (parseInt(priceBox.getAttribute('data-starting-price-cents') || '0', 10) || 0) : 0;

    var echo = document.createElement('div');
    echo.className = 'dusa-custom-coir-atc-price';
    echo.setAttribute('data-dusa-custom-coir-atc-price', '');
    echo.innerHTML =
      '<span class="dusa-custom-coir-atc-price__label" data-dusa-custom-coir-atc-price-label>Starting at</span>' +
      '<span class="dusa-custom-coir-atc-price__amount" data-dusa-custom-coir-atc-price-amount></span>';
    q(echo, '[data-dusa-custom-coir-atc-price-amount]').textContent = formatMoney(startingCents);
    buttons.parentNode.insertBefore(echo, buttons);
  }

  function injectConfiguratorHeader(root) {
    var dpo = q(root, '#itoris_dynamicproductoptions');
    if (!dpo || dpo.querySelector('.dusa-custom-coir-configurator__head')) return;

    var head = document.createElement('div');
    head.className = 'dusa-custom-coir-configurator__head';
    head.innerHTML =
      '<p class="dusa-custom-coir-configurator__eyebrow">Custom cut selector</p>' +
      '<h2 class="dusa-custom-coir-configurator__title">Configure your mat</h2>' +
      '<p class="dusa-custom-coir-configurator__copy">Choose size, thickness, and color. Price updates before cart.</p>';
    dpo.insertBefore(head, dpo.firstChild);
  }

  function injectSizeIntro(root) {
    var fieldset = q(root, '#fieldset-section-1');
    if (!fieldset || fieldset.querySelector('.dusa-custom-coir-size-intro')) return;

    var intro = document.createElement('div');
    intro.className = 'dusa-custom-coir-size-intro';
    intro.innerHTML =
      '<div class="dusa-custom-coir-size-diagram" aria-hidden="true">' +
        '<span class="dusa-custom-coir-size-diagram__mat"></span>' +
        '<span class="dusa-custom-coir-size-diagram__axis dusa-custom-coir-size-diagram__axis--length">Length</span>' +
        '<span class="dusa-custom-coir-size-diagram__axis dusa-custom-coir-size-diagram__axis--width">Width</span>' +
      '</div>' +
      '<div class="dusa-custom-coir-size-copy">' +
        '<h3>1. Select length × width</h3>' +
        '<p>Select finished size using feet plus half-inch increments.</p>' +
      '</div>';
    fieldset.insertBefore(intro, fieldset.firstChild);
  }

  function addOptionSectionLabels(root) {
    var thickness = q(root, '#dynamic_option_id_1005');
    var color = q(root, '#dynamic_option_id_1006');
    if (thickness && !thickness.querySelector('.dusa-custom-coir-step-title')) {
      thickness.insertAdjacentHTML('afterbegin', '<h3 class="dusa-custom-coir-step-title">2. Choose thickness</h3>');
    }
    if (color && !color.querySelector('.dusa-custom-coir-step-title')) {
      color.insertAdjacentHTML('afterbegin', '<h3 class="dusa-custom-coir-step-title">3. Choose color</h3>');
    }
  }

  function trimDescriptionLengthWidthCopy(root) {
    qa(root, '.product__description p, .rte p').forEach(function (paragraph) {
      var text = cleanText(paragraph.textContent);
      if (text.indexOf('Length is the depth of the mat') === -1 || text.indexOf('For recessed wells') === -1) return;
      paragraph.innerHTML = paragraph.innerHTML.replace(/^\s*<strong>\s*Length\s*<\/strong>\s*is the depth of the mat\s*[—-]\s*front to back as you walk across it\.\s*<strong>\s*Width\s*<\/strong>\s*is side to side,\s*usually the longer dimension across the doorway\.\s*/i, '');
    });
  }

  function bindLivePrice(root) {
    qa(root, 'select.product-custom-option').forEach(function (select) {
      if (select.getAttribute('data-dusa-live-price-bound') === 'true') return;
      select.setAttribute('data-dusa-live-price-bound', 'true');
      select.addEventListener('change', function () { updateLivePrice(root); });
      select.addEventListener('input', function () { updateLivePrice(root); });
    });
    updateLivePrice(root);
  }

  function enhance(root) {
    if (!root) return false;
    var fieldset = q(root, '#fieldset-section-1');
    if (!fieldset) return false;

    injectConfiguratorHeader(root);
    injectSizeIntro(root);
    injectAtcPriceEcho(root);

    Object.keys(FIELD_MAP).forEach(function (id) {
      var select = selectForField(root, id);
      if (!select) return;
      var config = FIELD_MAP[id];
      relabelField(select, config);
      if (config.mirror) createChoiceMirror(select, config.mirror);
    });

    var thicknessSelect = selectForField(root, THICKNESS_FIELD_ID);
    var colorSelect = selectForField(root, COLOR_FIELD_ID);
    if (thicknessSelect && colorSelect && !thicknessSelect.getAttribute('data-dusa-color-availability-bound')) {
      thicknessSelect.setAttribute('data-dusa-color-availability-bound', 'true');
      thicknessSelect.addEventListener('change', function () {
        enforceColorAvailability(root, { showResetNotice: true });
      });
    }
    if (colorSelect && !colorSelect.getAttribute('data-dusa-color-availability-bound')) {
      colorSelect.setAttribute('data-dusa-color-availability-bound', 'true');
      colorSelect.addEventListener('change', function () {
        enforceColorAvailability(root, { showResetNotice: false });
      });
    }
    enforceColorAvailability(root, { showResetNotice: false });
    bindLivePrice(root);

    addOptionSectionLabels(root);
    normalizeDimensionHelp(root);
    [250, 750, 1500, 3000].forEach(function (delay) {
      window.setTimeout(function () { normalizeDimensionHelp(root); }, delay);
    });
    trimDescriptionLengthWidthCopy(root);
    root.setAttribute(ENHANCED_ATTR, 'true');
    return true;
  }

  function boot() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    if (enhance(root)) return;

    var observer = new MutationObserver(function () {
      if (enhance(root)) observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (root.getAttribute(ENHANCED_ATTR) === 'true') observer.disconnect();
    }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('dpo_loading_finished', boot);
})();
